import TranslationImage from "../../Assets/Images/Illustrations/Translation.svg";
import PatChatImage from "../../Assets/Images/Illustrations/PatChat.svg";
import InventorAIImage from "../../Assets/Images/Illustrations/PrefilingSearch.svg";
import PatentDraftingImage from "../../Assets/Images/Illustrations/FirstDraft.svg";
import PrefilingSearchImage from "../../Assets/Images/Illustrations/PrefilingSearch.svg";
import ClaimChartingImage from "../../Assets/Images/Illustrations/ClaimChart.svg";
import ScoreCardImage from "../../Assets/Images/Illustrations/ScoreCard.svg";
import OAScoreCardImage from "../../Assets/Images/Illustrations/ScoreCard.svg";
import AIClassifier from "../../Assets/Images/Illustrations/ai_classifier.svg";
import InvaliditySearchImage from "../../Assets/Images/Illustrations/InvaliditySearch.svg";
import InterpretationChartImage from "../../Assets/Images/Illustrations/InterpretationCharts.svg";
import OfficeActionResponseImage from "../../Assets/Images/Illustrations/OfficeActionResponse.svg";
import IPWorkflowsImage from "../../Assets/Images/Illustrations/IPWorkflows.svg";
import TradeSecretImage from "../../Assets/Images/Illustrations/TradeSecret.svg";
import PatDiff from "../../Assets/Images/Illustrations/PatDiff.svg";
import TranslationSS from "../../Assets/Images/Screenshots/translation.png";
import ClaimChartSS from "../../Assets/Images/Screenshots/translation.png";
import PrefilingSearchSS from "../../Assets/Images/Screenshots/prefiling_search.png";
import InvaliditySearchSS from "../../Assets/Images/Screenshots/translation.png";
import FirstDraftSS from "../../Assets/Images/Screenshots/translation.png";
import InterpretationChartSS from "../../Assets/Images/Screenshots/translation.png";
import AIClassifierSS from "../../Assets/Images/Screenshots/translation.png";
import PatentDraftScoreCardSS from "../../Assets/Images/Screenshots/translation.png";
import OAScoreCardSS from "../../Assets/Images/Screenshots/translation.png";
import OAResponseSS from "../../Assets/Images/Screenshots/translation.png";
import TradeSecretSS from "../../Assets/Images/Screenshots/translation.png";
import PatChatSS from "../../Assets/Images/Screenshots/translation.png";
import PatDiffSS from "../../Assets/Images/Screenshots/translation.png";
import IPWorkflowSS from "../../Assets/Images/Screenshots/translation.png";
import UseCaseDiagrams, {UseCaseDiagramList} from "./UseCaseDiagrams";

export const UseCaseList = {
    first_draft:{
        Name: "First Draft",
        LinkName: "first_draft",
        Header: "First Draft - First Draft - Let AI do the manual work",
        SubHeader: "Let AI do the manual work",
        HomeSubHeader: "Let AI do the manual work",
        Description: <>
            Patent Application describes an invention in a clear, precise, and legally enforceable manner to obtain a patent and the process of creating the patent application is Patent drafting. Patent drafting is more of an art than science and AI Agents are here to help with the science so that the IP Attorneys can specialize in the art of creating high quality Patent Applications.
            <br/>
            <br/>First Draft AI Agent creates a first draft of a patent application from an invention within a minute. Kick start your patent application NOW!
        </>,
        Illustration: PatentDraftingImage,
        IllustrationDescription: "Interface view of the AI patent drafting tool in IP Agent AI, automatically generating the first draft of a patent application. This tool improves drafting efficiency and reduces manual work for IP professionals.",
        Icon: "first_draft",
        Available: true,
        Price: "$100/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Patent drafting is slow, expensive, and painfully complex — stealing time from innovation. Missed details or weak language can lead to costly rejections and wasted resources.",
                    },
                    {
                        Tag: "p",
                        Paragraph: "AI streamlines patent drafting by rapidly generating precise, legally sound drafts, reducing errors, cutting costs, and freeing inventors and attorneys to focus on innovation instead of paperwork.",
                    },

                ],

            },
            {
                Title: "How IP Agent solves it",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "IP Agent AI transforms an invention into a high-quality patent first draft using secure, proprietary AI models. Drawing insights from global patents and literature, it generates abstracts, titles, summaries, and claims. Users can refine drafts interactively until the desired quality is achieved, and the system also produces labeled patent diagrams ready for inclusion in applications.\n",
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: FirstDraftSS,
                                Name: "First Draft | IP Agent AI | Agentic AI Platform"
                            }
                        ]
                    },

                ],

            },
            {
                Title: "Why IP Agent AI’s First Draft? ",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "End-to-End Draft Generation",
                                ItemBody: [
                                    "IP Agent AI produces titles, abstracts, claims, and summaries from a single invention input. This saves attorneys and inventors countless hours by creating a complete, structured draft in one step."
                                ]
                            },

                            {
                                ItemTitle: "Private & Proprietary AI Models",
                                ItemBody: [
                                    "All processing happens within secure, proprietary AI models — never public ones. This ensures data confidentiality, compliance, and peace of mind for inventors and enterprises."
                                ]
                            },

                            {
                                ItemTitle: "Global Knowledge Integration",
                                ItemBody: [
                                    "The system analyzes worldwide patents and literature to ground drafts in the broadest possible context. This reduces the risk of overlooking prior art and increases the likelihood of stronger, defensible applications."
                                ]
                            },

                            {
                                ItemTitle: "Interactive Refinement",
                                ItemBody: [
                                    "Users can collaborate with the system, fine-tuning the draft until the required quality and precision are reached. This ensures the final patent application aligns perfectly with both legal and business goals."
                                ]
                            },

                            {
                                ItemTitle: "Automated Patent Diagrams",
                                ItemBody: [
                                    "Beyond text, the platform generates labeled diagrams ready for patent filings. Visuals make claims clearer and strengthen applications, cutting out the need for external design vendors."
                                ]
                            },

                            {
                                ItemTitle: "Error Reduction & Consistency",
                                ItemBody: [
                                    "AI-driven drafting minimizes human error and maintains consistent terminology across sections. This leads to more coherent applications that are less prone to rejection during examination."
                                ]
                            },

                            {
                                ItemTitle: "Time & Cost Efficiency",
                                ItemBody: [
                                    "By automating drafting and diagramming, IP Agent AI reduces attorney workload and eliminates expensive outsourcing. The result: faster filings at significantly lower cost, without sacrificing quality."
                                ]
                            },


                        ]
                    },
                    {
                        Tag: "diagram",
                        Diagram: <UseCaseDiagrams info={UseCaseDiagramList["FirstDraft"]}/>

                    }

                ],
            },

        ]
    },
    invalidity_search: {
        Name: "Invalidity Search",
        LinkName: "invalidity_search",
        Header: "AI-Powered Patent Invalidity. Trusted by Enterprises",
        SubHeader: "Defend Your Innovation",
        HomeSubHeader: "Defend Your Innovation",
        Description: <>
            Invalidate competitors’ patents efficiently with quantifiable metrics and detailed explanations—all in just minutes.
            <br/>
            <br/>
            Invalidity Searches are performed to identify prior art to challenge validity of a granted patent or a specific patent claim. This is needed during patent litigation, opposition proceedings or as part of pre-litigation assessment.
        </>,
        Illustration: InvaliditySearchImage,
        IllustrationDescription: "Interface view of invalidity search results in IP Agent AI, comparing prior art references with patent claims. This tool uses AI patent search to detect weaknesses and strengthen IP strategies.",
        Icon: "invalidity_search",
        Available: true,
        Price: "$2000/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Mitigate financial exposure and strengthen IP defenses through extensive, automated AI-powered Invalidity Searches.",
                    },

                ],

            },
            {
                Title: "Patent Invalidity Searches — Fast, Accurate, Defensible",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Invalidity searches uncover prior art to challenge patent validity when enterprises face infringement claims that threaten their products and innovation. Traditionally, these searches are labor-intensive, time-consuming, and costly — requiring specialized legal expertise.",

                    },
                    {
                        Tag: "p",
                        Paragraph:  "Overlooked prior art can derail legal strategies, exposing enterprises to financial and competitive risks — making invalidity searches  the cornerstone of IP defense.",
                    },

                    {
                        Tag: "p",
                        Paragraph:  "IP Agent AI delivers fast, precise invalidity searches powered by advanced AI. Our litigation-ready reports equip patent lawyers and corporations to challenge and invalidate patents confidently with evidence.",
                    },

                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: InvaliditySearchSS,
                                Name: "Invalidity Searches | IP Agent AI | Agentic AI Platform"
                            }
                        ]

                    },

                ],

            },
            {
                Title: "Why Choose Us for AI Invalidity Searches?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Guaranteed Precision",
                                ItemBody: [
                                    "Pinpoint accuracy often comes at a very high cost. With IP Agent AI-powered invalidity searches, you can analyze global patents and literature using proprietary generative ai and search techniques— reducing costly errors. The result: a faster, more reliable process that makes invalidating patents easier than ever."
                                ]
                            },
                            {
                                ItemTitle: "Speed and Efficiency",
                                ItemBody: [
                                    "Manual searches waste valuable time and are cost prohibitive. IP Agent AI delivers invalidity search results in minutes, not days — scanning global patents and obscure sources with advanced AI to streamline workflows and accelerate patent challenges.",

                                ]
                            },
                            {
                                ItemTitle: "Actionable Insights",
                                ItemBody: [
                                    "Vague data kills strategy. IP Agent AI turns prior art into power with litigation-ready insights, claim-focused reports, and visual maps — driving faster, stronger invalidation decisions."
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Who Uses IP Agent AI for Invalidity Searches?",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Law firms and enterprises worldwide rely on our proprietary AI-powered platform for fast, reliable IP invalidity searches.",
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Patent Lawyers",
                                ItemBody: [
                                    "IP Agent AI empowers patent lawyers with precise prior art discovery and litigation-ready insights — streamlining preparation and fortifying client defenses."
                                ]
                            },
                            {
                                ItemTitle: "Corporations",
                                ItemBody: [
                                    "Businesses rely on IP Agent AI for cost-effective invalidity searches, leveraging AI to identify weak competitor patents, reduce litigation risks, and safeguard market share.",
                                ]
                            },
                        ]
                    },


                ],
            },
            {
                Title: "Empower your litigation defense with evidence-backed insights provided by IP Agent AI",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Sign up for IP Agent AI today.",
                    },


                ],
            },
        ]
    },
    ai_classifier: {
        Name: "AI Classifier",
        LinkName: "ai_classifier",
        Header: "Patent Classification: From Weeks to Seconds",
        SubHeader: "Precise Patent Classification in Seconds",
        HomeSubHeader: "Find AI Classifier Home Sub Header",
        Description: <>
            IP Agent AI’s AI Classifier is designed to remove the bottlenecks and inconsistencies of traditional patent classification – standard or custom. Instead of relying on manual review, it uses domain specific fine-tuned Large Language Models(LLMs) trained on global patent datasets to classify patents with speed and precision.
        </>,
        Illustration: AIClassifier,
        IllustrationDescription: "AI Classifier feature of IP Agent AI showing magnifying glass with bar chart and classification boxes, describing AI patent analytics platform that automates patent classification using domain-specific LLMs, replacing manual review with precise AI patent categorization.",
        Icon: "ai_classifier",
        Available: true,
        Price: "$100/matter",
        SupportLawFirm: false,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Patent classification today is slow, inconsistent, and expensive — forcing experts to wade through dense disclosures and endless classifications. With millions of filings every year, manual methods can’t keep up, leaving portfolios vulnerable to errors and missed opportunities."
                    },
                    {
                        Tag: "p",
                        Paragraph: "AI helps classify patents faster and more consistently by analyzing technical disclosures and assigning CPC/IPC codes automatically. This reduces errors, lowers costs, and scales easily to handle the millions of patents filed worldwide each year."
                    },

                ],

            },
            {
                Title: "IP Agent AI Classifier - Transforming Patent Classification",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>IP Agent AI’s <b>AI Classifier</b> is designed to remove the bottlenecks and inconsistencies of traditional patent classification – standard or custom. Instead of relying on manual review, it uses domain specific fine-tuned Large Language Models(LLMs) trained on global patent datasets to classify patents with speed and precision. The system can recognize multiple technical aspects of an invention — such as structure, function, and application — and automatically assign primary, secondary and tertiary classifications.
                            This ensures that patents are consistently classified, reducing the risk of errors or omissions that often weaken searches and portfolio analysis. By automating a process that usually consumes hours of attorney or examiner time, the AI Classifier dramatically lowers costs while improving efficiency. It also scales effortlessly to handle large volumes of filings, making it ideal for enterprises, R&D teams, and law firms managing big portfolios. Ultimately, it transforms patent classification from a tedious administrative task into a reliable, strategic advantage.
                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: AIClassifierSS,
                                Name: "AI classifier | Classify Patents |  Intellectual property management AI for inventors | AI for inventors | AI software for inventors | Patent management for inventors | Manage inventor IP | IP Agent AI | Agentic AI Platform"
                            }
                        ]

                    },

                ],

            },


            {
                Title: "Why IP Agent AI’s AI Classifier?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Speed at Scale",
                                ItemBody: [
                                    "Traditional patent classification can take days or weeks for large volumes of applications. IP Agent AI’s classifier processes thousands of patents in minutes, ensuring organizations can keep pace with today’s rapid global filing rates. This speed allows teams to focus on strategy instead of administrative backlogs."
                                ]
                            },
                            {
                                ItemTitle: "High Accuracy & Consistency",
                                ItemBody: [
                                    "Human examiners often interpret claims differently, leading to inconsistent results across similar inventions. The AI Classifier applies standardized algorithms trained on global datasets, ensuring accurate and uniform CPC/IPC coding. This consistency reduces errors that could weaken searches or portfolio analysis.",

                                ]
                            },
                            {
                                ItemTitle: "Multi-Feature Recognition",
                                ItemBody: [
                                    "Most inventions touch on multiple technical aspects, but manual classification often focuses only on the “main” feature. IP Agent AI can recognize structure, function, and application simultaneously, assigning both primary and secondary classifications. This richer tagging makes patents more discoverable and searchable from different angles.",
                                ]
                            },
                            {
                                ItemTitle: "Cost Efficiency",
                                ItemBody: [
                                    "Relying on attorneys or specialists to classify patents is resource-intensive and expensive. By automating much of the process, IP Agent AI lowers operational costs while freeing experts to focus on higher-value legal or strategic work. The result is stronger IP management at a fraction of the cost.",
                                ]
                            },
                            {
                                ItemTitle: "Improved Search & Analytics",
                                ItemBody: [
                                    "Accurate classifications feed directly into better prior art searches, portfolio evaluations, and competitive intelligence. With AI-driven consistency, organizations can trust that related inventions will be grouped correctly, making analysis more reliable. This enhances decision-making across litigation, licensing, and R&D.",
                                ]
                            },
                            {
                                ItemTitle: "Scalable for Enterprises",
                                ItemBody: [
                                    "Corporations and law firms often manage portfolios with thousands of patents across multiple jurisdictions. IP Agent AI scales effortlessly, applying the same quality of classification whether handling 10 or 1,000,000 patents. This makes it ideal for enterprises with global innovation pipelines.",
                                ]
                            },
                            {
                                ItemTitle: "Future-Proof Technology",
                                ItemBody: [
                                    "Patent landscapes evolve quickly, with emerging technologies like AI, quantum computing, and biotech creating new categories. IP Agent AI continuously learns from fresh data and adapts to new terms and concepts. This ensures that classifications remain accurate and relevant, even as industries change.",
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "IP Agent AI’s AI Classifier for Faster, Smarter and Accurate Patent Classification",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            IP professionals face overwhelming volumes of patents that are slow, costly, and inconsistent to classify manually.
                            <b>
                                IP Agent AI’s AI Classifier delivers fast, accurate, and scalable classification — reducing errors, lowering costs, and giving IP teams the clarity they need to manage portfolios with confidence.
                            </b>
                        </>
                    },

                ],
            },
        ]
    },
    pat_chat: {
        Name: "PatChat",
        LinkName: "pat_chat",
        Header: "PatChat : Private AI Answers for Every IP Question",
        SubHeader: "Ask Anything IP",
        HomeSubHeader: "Ask Anything IP",
        Description: <>
            Chat with our IP AI Agent for instant answers to all your IP-related questions—saving you hours of tedious work!
            <br/><br/>
            Are you spending hours or days getting a report about your portfolio or about any patents? Are you constrained by the limited dashboards to understand your or your competitors portfolio?
            <br/><br/>
            Look no further, PatChat AI Agent will provide you with any answers instantly.
        </>,
        Illustration: PatChatImage,
        IllustrationDescription: "PatChat conversational interface in IP Agent AI where users can ask intellectual property questions. The AI patent assistant provides instant answers, making patent knowledge more accessible and interactive.",
        Icon: "patchat",
        Available: true,
        SupportLawFirm: false,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            <b>PatChat</b> is a secure, private large language model fine-tuned to answer IP and enterprise-specific questions by combining both private and public data sources. It enables attorneys and paralegals to instantly access accurate, context-rich answers, eliminating the need for hours of manual research. By streamlining knowledge retrieval, PatChat saves significant time every day while maintaining confidentiality and control over sensitive data.
                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: PatChatSS,
                                Name: "Pat Chat | Patent AI Assistance | IP Agent AI | Agentic AI Platform"
                            }
                        ],
                    },
                ],

            },
            {
                Title: "Why PatChat?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Time Savings",
                                ItemBody: [
                                    "Delivers instant, accurate answers to complex IP and enterprise questions, saving attorneys and paralegals hours every day."
                                ]
                            },

                            {
                                ItemTitle: "Private & Secure",
                                ItemBody: [
                                    "Runs on private LLMs, ensuring sensitive enterprise and client data never leaves the system or touches public models."
                                ]
                            },

                            {
                                ItemTitle: "Unified Knowledge Access",
                                ItemBody: [
                                    "Combines private enterprise data with public patent and legal information, giving users a single source of truth."
                                ]
                            },

                            {
                                ItemTitle: "Consistency & Accuracy",
                                ItemBody: [
                                    "Provides standardized, reliable answers across teams, reducing errors and inconsistencies in legal workflows."
                                ]
                            },

                            {
                                ItemTitle: "Improved Productivity",
                                ItemBody: [
                                    "Frees legal teams from repetitive research tasks, allowing them to focus on higher-value strategic work."
                                ]
                            },

                            {
                                ItemTitle: "Scalability",
                                ItemBody: [
                                    "Supports large legal departments and enterprises by handling thousands of queries without additional overhead."
                                ]
                            },

                            {
                                ItemTitle: "Faster Decision-Making",
                                ItemBody: [
                                    "By surfacing insights instantly, PatChat empowers attorneys and executives to make better IP and business decisions in real time."
                                ]
                            },

                        ]
                    },

                ],
            },
            {
                Title: "Who Uses PatChat?",
                Essential: true,
                Body: [
                    {
                        Tag: "",
                        Text: <h3>In-House Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Instant Legal Insights ",
                                ItemBody: [
                                    " Quickly answer patentability, prior art, and portfolio questions without long research cycles."
                                ]
                            },
                            {
                                ItemTitle: "Better Strategic Alignment",
                                ItemBody: [
                                    "Combine enterprise and public data to align IP strategy with business goals."
                                ]
                            },
                            {
                                ItemTitle: "Faster Decision-Making",
                                ItemBody: [
                                    "Provide executives and R&D with timely, data-backed recommendations."
                                ]
                            },
                        ]
                    },
                    {
                        Tag: "",
                        Text: <h3>Paralegals</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Time Savings",
                                ItemBody: [
                                    "Automate repetitive searches and data checks, eliminating hours of manual work."
                                ]
                            },
                            {
                                ItemTitle: "Error Reduction",
                                ItemBody: [
                                    "Consistently generate accurate answers and reduce oversight risks."
                                ]
                            },
                            {
                                ItemTitle: "Workflow Efficiency",
                                ItemBody: [
                                    "Streamline docketing, prior art lookups, and case prep."
                                ]
                            },
                            {
                                ItemTitle: "Scalability",
                                ItemBody: [
                                    "Handle higher workloads during peak filing or prosecution periods with ease."
                                ]
                            },
                        ]
                    },
                    {
                        Tag: "",
                        Text: <h3>Outside Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Stronger Client Service",
                                ItemBody: [
                                    "Deliver faster, consistent answers to client inquiries with AI-backed confidence."
                                ]
                            },
                            {
                                ItemTitle: "Efficiency at Scale",
                                ItemBody: [
                                    "Respond to multiple office actions and portfolio queries quickly."
                                ]
                            },
                            {
                                ItemTitle: "Higher-Value Focus",
                                ItemBody: [
                                    "Spend less time on basic research and more on crafting legal strategy."
                                ]
                            },
                            {
                                ItemTitle: "Client Trust ",
                                ItemBody: [
                                    "Offer transparency with data-backed, AI-generated insights that clients can rely on."
                                ]
                            },
                        ]
                    },

                ],
            },
        ]
    },
    patent_draft_score_card: {
        Name: "Patent Draft Score Card",
        LinkName: "patent_draft_score_card",
        Header: "AI-Powered Patent Draft Score Card",
        SubHeader: "Score and Improve Patent Drafts",
        SubTitle: "Backed by Data",
        HomeSubHeader: "Find Patent Draft Score Card",
        Description: "The Patent Draft Score Card delivers a quantifiable score across multiple evaluation points, paired with qualitative explanations for each. This gives attorneys a clear, data-backed way to analyze and demonstrate the strength of a patent application before filing. By ensuring higher draft quality upfront, it reduces or even eliminates office actions, accelerating approval and strengthening patent protection.",
        Illustration: ScoreCardImage,
        IllustrationDescription: "Illustration of a patent draft scorecard in IP Agent AI, displaying evaluation metrics and scoring bars to assess novelty and patent quality, powered by automated patent analysis, AI patent quality check, prior art search AI, and AI patent analytics platform",
        Icon: "patent_draft_score_card",
        Available: false,
        Price: "$100/matter",
        SupportLawFirm: true,

        Context: [
            {
                Title: "Patent Application Quality - Quantified",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            The <b>Patent Draft Score Card</b> delivers a quantifiable score across multiple evaluation points, paired with qualitative explanations for each. This gives attorneys a clear, data-backed way to analyze and demonstrate the strength of a patent application before filing. By ensuring higher draft quality upfront, it reduces or even eliminates office actions, accelerating approval and strengthening patent protection.

                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: PatentDraftScoreCardSS,
                                Name: "Patent Draft Score Card | IP Agent AI | Agentic AI Platform"
                            }
                        ],
                    },
                ],

            },
            {
                Title: "Why use Patent Draft Score Card?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Quantifiable Draft Quality",
                                ItemBody: [
                                    "Gives each patent draft a measurable score, helping attorneys evaluate strength with clarity and confidence."
                                ]
                            },

                            {
                                ItemTitle: "Detailed Qualitative Feedback",
                                ItemBody: [
                                    "Provides explanations alongside scores, showing exactly why a draft is strong or weak and where improvements are needed."
                                ]
                            },

                            {
                                ItemTitle: "Error Reduction",
                                ItemBody: [
                                    "Helps identify gaps or inconsistencies in the draft that could trigger costly office actions later."
                                ]
                            },

                            {
                                ItemTitle: "Faster Approvals",
                                ItemBody: [
                                    "By improving draft quality upfront, it reduces examiner objections and accelerates the path to patent grant."
                                ]
                            },

                            {
                                ItemTitle: "Cost Efficiency",
                                ItemBody: [
                                    "Minimizes rework, revisions, and office action responses — lowering attorney time and overall filing costs."
                                ]
                            },

                            {
                                ItemTitle: "Consistency Across Applications",
                                ItemBody: [
                                    "Applies the same scoring framework to every draft, ensuring uniform quality across large portfolios."
                                ]
                            },

                            {
                                ItemTitle: "Stronger IP Protection",
                                ItemBody: [
                                    "Data-driven scoring and feedback lead to more defensible, litigation-ready patents that hold long-term value."
                                ]
                            },

                        ]
                    },

                ],
            },

        ]
    },
    claim_charts:{
        Name: "Claim Charts",
        LinkName: "claim_charts",
        Header: "IP Agent AI’ Claim Charts for Effective Patent Protection",
        SubHeader: "Identify Infringers",
        HomeSubHeader: "Identify Infringers",
        Description: <>
            Claim Charts are used to map patent claims to commercialized products by enterprises to analyze infringement of the patents. Claim Charts AI Agent helps enterprises to create Claim Chart in the matter of minutes.
        </>,
        Illustration: ClaimChartingImage,
        IllustrationDescription: "Claim chart showing how patent claims are mapped against product features, created with patent analytics and AI in IP Agent AI. This helps IP professionals detect possible infringement with improved accuracy and efficiency.",
        Icon: "claim_chart",
        Available: true,
        Price: "$2000/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Claim charts are critical for enterprises to systematically map patent claims to specific products, services, or industry standards, enabling them to assess infringement risks, validate patent strength, and enhance IP portfolio management. By providing clear, visual evidence of how claims align with technologies, they empower enterprises to strengthen licensing negotiations, defend against litigation, and make informed strategic decisions in a competitive market.",
                    },

                ],

            },
            {
                Title: "Make Light Work of Patent Analysis with AI Claim Charting",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "IP claim charting is a powerful, visual way to compare your patent elements against competitors. With IP Agent AI, you can map claims to products, prior art, or other patents — simplifying infringement and invalidity analysis in minutes.",
                    },
                    {
                        Tag: "p",
                        Paragraph:  "Stop wasting time on manual comparisons. IP Agent AI delivers intuitive, accurate claim charts that make patent analysis faster, smarter, and more cost-effective.",
                    },
                    {
                        Tag: "p",
                        Paragraph:  "Try IP Agent AI today and create detailed claim charts that strengthen your IP strategy while keeping costs low."
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: ClaimChartSS,
                                Name: "Claim Chart| IP Agent AI | Agentic AI Platform"
                            }
                        ]

                    },

                ],

            },


            {
                Title: "Why Choose Us for Creating IP Claim Charts?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Precise Claim Mapping",
                                ItemBody: [
                                    "Inaccurate mappings can undermine patent cases. Our claim chart AI ensures precision by analyzing claims against products or prior art, delivering litigation-ready charts that strengthen your IP strategy."
                                ]
                            },
                            {
                                ItemTitle: "Rapid Analysis Speed",
                                ItemBody: [
                                    "Manual claim charting is time-consuming and distracting. IP Agent AI generates accurate charts in minutes, freeing you to focus on your core responsibilities.",

                                ]
                            },
                            {
                                ItemTitle: "Actionable Claim Insights",
                                ItemBody: [
                                    "Create effective IP claim charts with clear, actionable insights. Our AI-driven reports and visual mappings simplify infringement and invalidity arguments, empowering you to build stronger patent cases with confidence.",
                                ]
                            },
                            {
                                ItemTitle: "Cost-Effective Analysis",
                                ItemBody: [
                                    "Manual analysis drains resources. Our claim chart AI automates comparisons of patent elements against competitors, reducing costs and risks while delivering high-impact results at a fraction of traditional costs.",
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Leverage IP Agent AI Platform for Claim Charts",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Traditional claim charting pulled inventors, developers, and creatives away from their core work. With IP Agent AI, the process is streamlined and effortless by comparison.",
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Map Claims to Products",
                                ItemBody: [
                                    "Use our platform to generate AI-driven claim charts that precisely map patent claims to product features. Patent lawyers and corporations benefit from faster, clearer infringement proof with evidence-backed visuals built to stand up in court."
                                ]
                            },
                            {
                                ItemTitle: "Accelerate Litigation Prep",
                                ItemBody: [
                                    "IP Agent AI generates litigation-ready visuals in minutes, streamlining preparation and giving patent lawyers all the relevant data to build strong cases quickly.",
                                ]
                            },
                            {
                                ItemTitle: "Reduce Analysis Risks",
                                ItemBody: [
                                    "IP Agent AI reduces errors in claim mapping through precise AI analysis, helping corporations avoid weak arguments and overlooked prior art in disputes.",
                                ]
                            },
                            {
                                ItemTitle: "Provide Actionable Insights",
                                ItemBody: [
                                    "AI-generated charts and reports provide clarity for strategic IP decisions — equipping users to manage patent claims effectively and protect their IP.",
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Your Powerful Claim Chart AI Is Ready to Go",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Don’t let complex patent analysis slow you down. With IP Agent AI, map claims accurately and efficiently — and keep your focus on success.",
                    },
                    {
                        Tag: "button",
                        Label: "Sign Up Today"
                    }


                ],
            },
        ]
    },
    inventor_ai_assist: {
        Name: "Inventor AI Assist",
        LinkName: "inventor_ai_assist",
        SubHeader: "Invent Smartly",
        Header: "Empowering inventors with instant patent intelligence",
        HomeSubHeader: "Invent Smartly",
        Description: <>
            Fine-tune your inventions, validate patentability, and save thousands of dollars and countless hours of effort.
        </>,
        Illustration: InventorAIImage,
        IllustrationDescription: "Inventor AI Assist tool inside IP Agent AI helps innovators validate patentability, run prior art searches, and analyze patents. It streamlines patent research and supports better decision-making for inventors and IP attorneys.",
        Icon: "inventors_ai",
        Available: true,
        Price: "Contact Us",
        SupportLawFirm: true,
        Context: [
            {
                Title: "Intelligent Invention Management for Inventors",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Inventor AI Assist is a cutting-edge tool designed for inventors to simplify invention management and protect groundbreaking ideas. Our AI-powered software streamlines the process of refining patentable concepts, performing smart searches, and guiding your innovations to market with ease.",
                    },
                    {
                        Tag: "p",
                        Paragraph: "Unsure if your idea qualifies for a patent? Our intuitive platform delivers fast, accurate insights to fuel your creativity.",
                    },
                    {
                        Tag: "p",
                        Paragraph: "Built for inventors, by inventors, Inventor AI Assist elevates your ideation process. Start your free trial today and experience smarter innovation!",
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: ClaimChartSS,
                                Name: "Claim Chart | IP Agent AI | Agentic AI Platform"
                            }
                        ]

                    },

                ],

            },
            {
                Title: "Why Choose Us for Inventor AI Assist?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Intuitive Idea Validation",
                                ItemBody: [
                                    "Unvalidated ideas risk rejection. Inventor AI Assist reduces that risk by researching and checking against global patents and literature to confirm novelty — empowering inventors with reliable insights for strong, patentable concepts."
                                ]
                            },
                            {
                                ItemTitle: "Lightning-Fast Ideation",
                                ItemBody: [
                                    "Our AI for inventors helps you develop and refine ideas to ensure they are truly unique and patentable. By rapidly analyzing vast datasets, it accelerates innovation without compromising creativity — giving you more time to invent and less time on admin.",

                                ]
                            },
                            {
                                ItemTitle: "Actionable Patent Insights",
                                ItemBody: [
                                    "Weak guidance can stall patents. Inventor AI Assist provides clear steps, precise reports, and claim suggestions — empowering you to craft patent-ready concepts before investing in marketing, production, or commercialization.",
                                ]
                            },
                            {
                                ItemTitle: "Cost-Effective Innovation",
                                ItemBody: [
                                    "Cut costs, not innovation. Inventor AI Assist automates idea validation, reducing risks and delivering affordable, high-impact results.",
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Inventor AI Assist for Inventors in Action",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Most invention management systems slow down the creative process. Inventor AI Assist solves this by streamlining IP tasks, giving inventors more time to focus on innovation and development.",
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Generate Patentable Ideas",
                                ItemBody: [
                                    "Inventor AI Assist plays a pivotal role in shaping unique concepts by analyzing vast global data. Our advanced platform helps inventors and R&D teams refining their novel ideas that stand out while minimizing the risk of unoriginal submissions."
                                ]
                            },
                            {
                                ItemTitle: "Validate Idea Novelty",
                                ItemBody: [
                                    "Inventor AI Assist scans global patents and literature with AI-powered searches to confirm novelty — helping inventors avoid pursuing concepts likely to be rejected by prior art.",
                                ]
                            },
                            {
                                ItemTitle: "Refine Concepts for Patentability",
                                ItemBody: [
                                    "The platform delivers AI-driven suggestions to refine ideas, enabling inventors to develop stronger, more defensible products with greater chances of patenting success.",

                                ]
                            },
                            {
                                ItemTitle: "Accelerate Ideation Process",
                                ItemBody: [
                                    "Our AI software evaluates ideas in minutes, not days — streamlining innovation workflows so inventors and teams can focus on creation and not left in limbo.",

                                ]
                            },
                            {
                                ItemTitle: "Reduce Patent Application Risks",
                                ItemBody: [
                                    "By identifying potential prior art early, Inventor AI Assist helps minimize the risk of costly patent rejections or disputes — simplifying the financial and legal side of innovation.",

                                ]
                            },

                        ]
                    },

                ],
            },
            {
                Title: "Utilize Inventor AI Assist for Inventions and Watch Your Productivity Soar",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Your time is too valuable for patent research. With IP Agent AI, you can focus on innovation while we handle the rest — empowering you to take full control of the creative process.",
                    },
                    {
                        Tag: "button",
                        Label: "Get Started"
                    }


                ],
            },

        ]
    },
    ip_translation:{
        Name: "IP Translations",
        LinkName: "ip_translation",
        Header: "IP Translations",
        SubHeader: "Seamless Translations for Foreign Filings",
        HomeSubHeader: <>
            Seamless Translations for
            <br/>Foreign Filings
            </>,
        Description: <>
            Translating IP patents and communicating with PTOs can be a major bottleneck, consuming valuable time and effort. With IP Agent’s free AI-powered translation AI Agent, streamline your major translation tasks instantly. Manage all your translation workflows in one place for a seamless and efficient experience.
        </>,
        Illustration: TranslationImage,
        IllustrationDescription: "Interface view of IP Agent AI’s translation feature, converting patent documents into multiple languages. It provides a first draft translation with AI patent assistant tools, saving time for professionals before validation by translators.",
        Icon: "ip_translation",
        Available: true,
        Price: "$1/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "IP translation involves translating a patent application or granted patent from one language to another, as well as facilitating communication with patent offices and attorneys in foreign countries . These are critical tasks in the patenting process, especially for filing patents internationally or enforcing them in jurisdictions with different official languages.",
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: TranslationSS,
                                Name: "Translation | IP Agent AI | Agentic AI Platform"
                            },
                        ]

                    },
                ],

            },
            {
                Title: "Why Are Patent Translations Needed?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "International Patent Filings",
                                ItemBody: [
                                    "When filing patents in multiple countries, translations are required to comply with the official languages of those jurisdictions."
                                ]
                            },

                            {
                                ItemTitle: "Legal Enforcement",
                                ItemBody: [
                                    "Accurate translations ensure that the patent’s scope and claims are upheld during litigation or examination in foreign jurisdictions."
                                ]
                            },

                            {
                                ItemTitle: "Collaboration",
                                ItemBody: [
                                    "Translations help inventors, attorneys, and examiners collaborate across different linguistic and cultural boundaries."
                                ]
                            },



                        ]
                    },

                ],
            },
            {
                Title: "FAQ",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "How are the translations done by IP Agent AI?",
                                ItemBody: [
                                    "The translations are done using google translate and privately hosted llms."
                                ]
                            },
                            {
                                ItemTitle: "Are the translations comprehensive?",
                                ItemBody: [
                                    "NO. The translations must be used as first cut and validated with professional translators. IP Agent AI bears no responsibility for the accuracy of the translations."
                                ]
                            },
                            {
                                ItemTitle: "Why do I need to use the free translation provided by IP Agent AI when I need a professional translator?",
                                ItemBody: [
                                    "IP Agent AI does majority of the translation work and the professional translators do the validation and refining the translation there by time and money for the customers. Professional translators can focus on the more intriguing and fun part of translations and avoid mundane work."
                                ]
                            },
                        ]
                    },

                ],
            },
        ]

    },
    office_action_response:{
        Name: "Office Action(OA) Response",
        LinkName: "office_action_response",
        SubHeader: "Respond Comprehensively",
        Header: "Ability to focus on high-value strategic work rather than lengthy reviews.",
        HomeSubHeader: "Respond Comprehensively",
        Description: <>
            Patent approval takes time, your office action response doesn’t have to. Reply to Office Actions with Office Action Response AI Agent qualitatively within minutes.
        </>,
        Illustration: OfficeActionResponseImage,
        IllustrationDescription: "AI-driven office action response tool in IP Agent AI that drafts replies for patent attorneys. It accelerates prosecution, reduces manual effort, and improves response quality with AI patent assistant features.",
        Icon: "oa_response",
        Available: true,
        Price: "$100/matter",
        SupportLawFirm: true,

        Context: [
            {
                Title: "AI Precision for Stronger Office Action Responses",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Office action responses drain time and resources, forcing attorneys to analyze objections and draft arguments under intense deadlines. The process is costly, error-prone, and slows innovation. Missed details or rushed replies can trigger repeat actions and weaken patent protection."
                    },
                    {
                        Tag: "p",
                        Paragraph: "AI streamlines office action responses by automatically analyzing examiner objections, reviewing prior art, and suggesting precise legal arguments tailored to the claims. This reduces attorney workload, minimizes errors, and enables faster, more cost-effective responses that strengthen patent protection.",

                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: OAResponseSS,
                                Name: "Office Action Response | IP Agent AI | Agentic AI Platform"
                            }
                        ]
                    },
                ],

            },
            {
                Title: "AI Powered Office Action Responses",
                Essential: false,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Faster Turnaround",
                                ItemBody: [
                                    "AI drafts responses in hours instead of days or weeks, keeping patent applications moving without delays."
                                ]
                            },

                            {
                                ItemTitle: "Higher Accuracy",
                                ItemBody: [
                                    "By analyzing claims, prior art, and examiner objections systematically, AI minimizes errors and inconsistencies in responses."
                                ]
                            },

                            {
                                ItemTitle: "Lower Costs",
                                ItemBody: [
                                    "Automation reduces manual attorney workload, cutting costs while still delivering high-quality, prosecution-ready drafts."
                                ]
                            },

                        ]
                    },
                ],

            },
            {
                Title: "Why Choose IP Agent AI for Office Action Responses?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Speed and Efficiency",
                                ItemBody: [
                                    "Traditional office action responses can take days or weeks. IP Agent AI accelerates the process by drafting structured responses in hours, keeping filings on track."
                                ]
                            },

                            {
                                ItemTitle: "Error Reduction",
                                ItemBody: [
                                    "Manual drafting risks inconsistencies or overlooked examiner objections. AI ensures precise, consistent responses by analyzing claims, prior art, and examiner language systematically."
                                ]
                            },

                            {
                                ItemTitle: "Cost Savings",
                                ItemBody: [
                                    "Responding to office actions often consumes expensive attorney hours. Automation reduces the manual workload, lowering costs while maintaining high-quality results."
                                ]
                            },

                            {
                                ItemTitle: "Prosecution-Ready Drafts",
                                ItemBody: [
                                    "The system generates structured, legally sound responses with clear references, providing drafts that are strong enough to hold up under scrutiny.\n"
                                ]
                            },

                            {
                                ItemTitle: "Improved Quality and Consistency",
                                ItemBody: [
                                    "Minimizes rework, revisions, and office action responses — lowering attorney time and overall filing costs."
                                ]
                            },

                            {
                                ItemTitle: "Consistency Across Applications",
                                ItemBody: [
                                    "AI reviews claims and prior art with the same logic every time, producing responses that are coherent, thorough, and aligned with best practices."
                                ]
                            },

                            {
                                ItemTitle: "Scalability for Enterprises",
                                ItemBody: [
                                    "Organizations managing large patent portfolios can handle multiple office actions at once. AI scales effortlessly, reducing bottlenecks in busy IP departments."
                                ]
                            },
                            {
                                ItemTitle: "Attorney Empowerment",
                                ItemBody: [
                                    "IP Agent AI acts as a response drafting assistant. Attorneys can focus on refining arguments and strategy while the system handles repetitive groundwork."
                                ]
                            },

                        ]
                    },

                ],
            },
            {
                Title: "Who Uses IP Agent AI for Office Action Response?",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Text: "Law firms and enterprises worldwide rely on our proprietary AI-powered platform for fast, precise and comprehensive Office Action Responses.\n"
                    },
                    {
                        Tag: "",
                        Text: <h3>In-House Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Use Cases:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Quickly generate draft responses to office actions for large patent portfolios.</li>
                                        <li>Provide R&D teams and executives with faster clarity on examiner objections and next steps.</li>
                                    </ul>
                                ]
                            },
                            {
                                ItemTitle: "Benefits:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Maintain greater control and visibility over the response process.
                                        </li>
                                        <li>Accelerate filings to protect innovation pipelines.</li>
                                    </ul>
                                ]
                            },
                        ]
                    },
                    {
                        Tag: "",
                        Text: <h3>Outside Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Use Cases:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Use AI-generated drafts as a starting point for precise legal arguments.</li>
                                        <li>Streamline preparation of office action responses across multiple clients.</li>
                                        <li>Deliver faster turnaround and consistent quality under tight deadlines.</li>
                                    </ul>
                                ]
                            },
                            {
                                ItemTitle: "Benefits:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Save billable hours on routine drafting tasks.</li>
                                        <li>Strengthen client trust with efficient, high-quality responses.</li>
                                        <li>Scale capacity to handle more clients without expanding headcount.</li>

                                    </ul>
                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Empower your prosecution defense with evidence-backed insights provided by IP Agent AI\n",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Text: "Sign up for IP Agent AI today."
                    },
                ],
            },
        ]
    },
    interpretation_charts:{
        Name: "Interpretation Charts",
        LinkName: "interpretation_charts",
        Header: "IP Agent AI’s Interpretation Charts\n" +
            "Transforms Patent Claims into Clarity",
        SubHeader: "Understand Claims Deeply",
        HomeSubHeader: "Understand Claims Deeply",
        Description: <>
            Analyze your claims qualitatively and quantitatively with Interpretation Chart AI Agent.
        </>,
        Illustration: InterpretationChartImage,
        IllustrationDescription: "Interpretation claim chart illustrating the meaning of patent claim language, supported by automated patent analysis in IP Agent AI. It helps professionals interpret claims accurately and reduce errors in prosecution or litigation.",
        Icon: "interpretation_chart",
        Available: true,
        Price: "$100/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Traditionally, creating interpretation charts manually is slow, expensive, and labor-intensive, requiring attorneys to break down complex claims and map them to evidence by hand. The process is error-prone and inconsistent, often draining resources and delaying critical IP decisions.",
                    },
                    {
                        Tag: "p",
                        Paragraph: "AI Interpretation Charts can automatically break down patent claims into clear components, interpret them in plain language, and map each element to supporting evidence from specifications, prior art, or product documentation. By automating this process, AI delivers consistent, litigation-ready interpretation charts in minutes instead of days.",
                    },
                ],

            },
            {
                Title: " How IP Agent solves it",
                Essential: false,
                Body: [
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: InterpretationChartSS,
                                Name: "Interpretation Charts | IP Agent AI | Agentic AI Platform"
                            }
                        ]

                    },
                    {
                        Tag: "p",
                        Paragraph: "IP Agent AI takes the pain out of interpretation charts by automating claim breakdowns and evidence mapping in minutes. No more costly manual effort or inconsistent results — every chart is accurate, consistent, and litigation-ready. Scale effortlessly across portfolios and cases while focusing on strategy, not paperwork.",
                    },

                ],

            },
            {
                Title: "Why IP Agent AI’s Interpretation Charts?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Speed Instead of Delay",
                                ItemBody: [
                                    <>
                                        Manual interpretation charts often take days or weeks, slowing down patent drafting, litigation, or licensing workflows. <b>IP Agent AI generates charts in minutes</b>, enabling attorneys and enterprises to respond quickly without bottlenecks.
                                    </>
                                ]
                            },
                            {
                                ItemTitle: "Lower Costs",
                                ItemBody: [
                                    <>
                                        Traditional charting requires expensive attorney or paralegal hours, which drives up costs for both law firms and corporations. <b>By automating the process, IP Agent AI slashes labor costs</b>, freeing teams to focus on higher-value strategic work.
                                    </>,

                                ]
                            },
                            {
                                ItemTitle: "Accuracy & Consistency",
                                ItemBody: [
                                    <>
                                        Human error and subjective judgment can lead to inconsistent claim interpretations across different attorneys or cases. <b>IP Agent AI ensures precision and consistency</b> by applying standardized, AI-driven analysis to every chart.
                                    </>
                                ]
                            },
                            {
                                ItemTitle: "Scalable for Portfolios & Litigation",
                                ItemBody: [
                                    <>
                                        Managing large portfolios or multiple disputes with manual charts is resource-intensive and often unmanageable. <b>IP Agent AI scales effortlessly</b>, producing hundreds of interpretation charts at the same high quality, regardless of volume.
                                    </>

                                ]
                            },
                            {
                                ItemTitle: "Evidence-Backed & Litigation-Ready",
                                ItemBody: [
                                    <>
                                        Manually mapping claims to specifications, figures, or prior art is tedious and prone to missed connections. <b>IP Agent AI automates evidence mapping</b>, producing litigation-ready charts with clear, verifiable references.
                                    </>

                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Who uses IP Agent AI’s Interpretation Charts?",
                Essential: true,
                Body: [
                    {
                        Tag: "",
                        Text: <h3>In-House Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Use Cases:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Evaluate competitor patents before product launches.</li>
                                        <li>Support licensing and partnership negotiations by clarifying claim scope.</li>
                                        <li>Communicate claim interpretations clearly to R&D and executives.</li>
                                    </ul>
                                ]
                            },
                            {
                                ItemTitle: "Benefits:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Reduce litigation and business risk.</li>
                                        <li>Align IP strategy with corporate goals.</li>
                                        <li>Lower reliance on costly outside counsel.</li>
                                    </ul>
                                ]
                            },
                        ]
                    },
                    {
                        Tag: "",
                        Text: <h3>Outside Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Use Cases:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Evaluate competitor patents before product launches.</li>
                                        <li>Support licensing and partnership negotiations by clarifying claim scope.</li>
                                        <li>Communicate claim interpretations clearly to R&D and executives.</li>
                                    </ul>
                                ]
                            },
                            {
                                ItemTitle: "Benefits:",
                                ItemBody: [
                                    <ul className="use-case-detail-sub-list">
                                        <li>Reduce litigation and business risk.</li>
                                        <li>Align IP strategy with corporate goals.</li>
                                        <li>Lower reliance on costly outside counsel.</li>
                                    </ul>
                                ]
                            },
                        ]
                    },


                ],
            },
        ]
    },

    prefiling_search:{
        Name: "Prefiling Search",
        LinkName: "prefiling_search",
        SubHeader: "Search Smarter, File Stronger",
        Header: "AI-Powered Prefiling Searches",
        HomeSubHeader: "Respond Comprehensively",
        Description: "Evaluate an invention’s novelty and patentability upfront in seconds. With IP Agent AI’s automated pre-filing searches, you reduce cost, minimize risk, and invest in IP with confidence.",
        Illustration: PrefilingSearchImage,
        IllustrationDescription: "Illustration representing AI-powered pre-filing patent search in IP Agent AI, showing discovery of prior art, novelty evaluation, and actionable insights to strengthen patentability, powered by prior art search AI, automated patent analysis, AI patent analytics platform, and patent research tools.",
        Icon: "prefiling_search",
        Available: true,
        Price: "$100/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "Find it First – File it Right",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Pre-filing patent searches today are painfully slow, costly, and unreliable, leaving critical prior art hidden in plain sight. The result? Weak patents, wasted dollars, and innovation dead on arrival.",
                    },
                    {
                        Tag: "p",
                        Paragraph: "AI-powered pre-filing searches deliver instant, accurate prior art insights—saving time, cutting costs, and strengthening every patent you file.",
                    },
                ],

            },
            {
                Title: "Qualitative Clarity, Quantitative Confidence",
                Essential: false,
                Body: [
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: PrefilingSearchSS,
                                Name: "Prefiling Searches | IP Agent AI | Agentic AI Platform"
                            }
                        ]

                    },
                    {
                        Tag: "p",
                        Paragraph: "Evaluate an invention’s novelty and patentability upfront in seconds. With IP Agent AI’s automated pre-filing searches, you reduce cost, minimize risk, and invest in IP with confidence.",
                    },

                    {
                        Tag: "p",
                        Paragraph: "Overlook prior art and you risk rejections, weak patents, and lost ground. Smart enterprises make patentability searches the backbone of their IP strategy.",
                    },

                    {
                        Tag: "p",
                        Paragraph: "Stronger patents start here — IP Agent AI delivers rapid, precise pre-filing searches with clear, actionable insights",
                    },

                ],

            },
            {
                Title: "Why Choose Us for Patent Prefiling Searches?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Comprehensive Prior Art Discovery",
                                ItemBody: [
                                    "Avoid costly rejections from incomplete searches. IP Agent AI scans worldwide patents and obscure literature, delivering complete prior art discovery to secure stronger, rejection-resistant applications",

                                ]
                            },
                            {
                                ItemTitle: "Unsurpassed Search Speed",
                                ItemBody: [
                                    "IP Agent AI turns weeks into seconds. Our advanced AI scans patents and non-patent sources fast, giving you rapid, reliable results to strengthen every application.",

                                ]
                            },
                            {
                                ItemTitle: "Actionable Insights",
                                ItemBody: [
                                    "Don’t let vague prior art weaken your case. IP Agent AI’s clear insights, detailed reports, and precise claim mapping help you draft stronger, rejection-proof patents.",

                                ]
                            },
                            {
                                ItemTitle: "Cost-Effective Patentability Search ",
                                ItemBody: [
                                    "Automate prior art analysis to reduce manual effort, cut costs, and minimize rejection",

                                ]
                            },
                        ]
                    },

                ],
            },
            {
                Title: "Who Uses IP Agent AI for Novelty Searches?",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "IP Agent AI’s pre-filing search identifies prior art instantly, boosting reliability and accuracy — the trusted choice for patentability decisions.",
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Corporate IP Counsels",
                                ItemBody: [
                                    "Corporate IP counsels leverage IP Agent AI’s AI-powered novelty searches to detect prior art early, reduce filing risks, and ensure stronger, defensible patents across their portfolios",
                                ]
                            },
                            {
                                ItemTitle: "Patent Attorneys",
                                ItemBody: [
                                    "IP Agent AI turns weeks into seconds. Our advanced AI scans patents and non-patent sources fast, giving you rapid, reliable results to strengthen every application.",

                                ]
                            },
                            {
                                ItemTitle: "Research and Development Teams",
                                ItemBody: [
                                    "R&D teams depend on our patent prefiling searches to confirm the uniqueness of their products. We are helping these teams minimize risks and optimize resources.",

                                ]
                            },
                            {
                                ItemTitle: "Inventors",
                                ItemBody: [
                                    "Inventors trust IP Agent AI to verify the patentability of their ideas. They rely on the platform’s AI-driven prior art searches to deliver fast, clear insights that guarantee strong and affordable patent applications.",

                                ]
                            },
                        ]
                    },
                    {
                        Tag: "diagram",
                        Diagram: <UseCaseDiagrams info={UseCaseDiagramList["PrefilingSearches"]}/>

                    }

                ],
            },
            {
                Title: "AI-Enable Your Patentability Search Today",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Patent rejections can be costly, and weak patents drain enterprise resources — damaging both reputation and the bottom line. Protect your IP strategy. Start using IP Agent AI today.",
                    },
                    {
                        Tag: "button",
                        Label: "Start Free Trial of IP Agent for AI Today"
                    },


                ],
            },
        ]


    },
    ip_workflows: {
        Name: "IP Workflows",
        LinkName: "ip_workflows",
        SubHeader: <>
            Smarter Workflows for Smarter Professionals
        </>,
        HomeSubHeader: <>
            Smarter Workflows for
            <br/>Smarter Professionals
        </>,
        Header: "Liberating IP Docketing with Open Access",
        Description: <>
            Seamless IP Workflows from ideation to enforcement using Agentic AI - open standards ensuring portability across IP Platforms.        </>,
        Illustration: IPWorkflowsImage,
        IllustrationDescription: "Workflow illustration in IP Agent AI showing how patent drafting, prior art search, and prosecution tasks are automated. It enables professionals to streamline complex IP processes with AI-driven efficiency.",
        Icon: "ip_workflow",
        Available: false,
        Price: "$100/matter",
        SupportLawFirm: false,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            IP Agent AI’s IP Workflows is an AI powered, <b>open schema, open-source IP docketing system</b> gives enterprises full control and portability of their IP data, free from vendor lock-in. It enables seamless integration with modern tools and AI workflows, ensuring transparency, flexibility, and long-term scalability.
                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: IPWorkflowSS,
                                Name: "Ip Workflow | IP Agent AI | Agentic AI Platform"
                            }
                        ],
                    },
                ],

            },
            {
                Title: "Why IP Agent AI’s IP Workflows?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "No Vendor Lock-In",
                                ItemBody: [
                                    "Enterprises aren’t tied to a single proprietary system — they can migrate or integrate freely without costly barriers."
                                ]
                            },

                            {
                                ItemTitle: "Full Data Ownership",
                                ItemBody: [
                                    "With an open schema, organizations retain complete control and transparency over how their IP data is structured and stored."
                                ]
                            },
                            {
                                ItemTitle: "Interoperability",
                                ItemBody: [
                                    "The system integrates seamlessly with AI tools, analytics, and third-party platforms, creating a connected IP ecosystem."
                                ]
                            },

                            {
                                ItemTitle: "Customization & Flexibility",
                                ItemBody: [
                                    "Being open source, the platform can be tailored to unique workflows, industry requirements, or enterprise preferences."
                                ]
                            },

                            {
                                ItemTitle: "Cost Efficiency",
                                ItemBody: [
                                    "Lower licensing fees and freedom from proprietary restrictions reduce overall operating costs while expanding functionality."
                                ]
                            },

                            {
                                ItemTitle: "Future-Proofing",
                                ItemBody: [
                                    "Open standards ensure long-term usability, keeping IP data accessible and adaptable as technology evolves."
                                ]
                            },

                            {
                                ItemTitle: "Community-Driven Innovation",
                                ItemBody: [
                                    "An open-source community continuously improves the system, adding features, fixing bugs, and driving innovation faster than closed vendors."
                                ]
                            },


                        ]
                    },

                ],
            },

        ]
    },
    oa_response_score_card: {
        Name: "OA Response Score Card",
        LinkName: "oa_response_score_card",
        Header: "AI-Powered Office Action Response Score Card",
        SubTitle: "Analyze in Minutes",
        SubHeader: "Quantify OA Response Strength Instantly",
        HomeSubHeader: "Find Patent Draft Score Card",
        Description: <>
            IP Agent AI’s patent pending The <b>Office Action Response Score Card</b> gives attorneys a clear, quantifiable score across multiple points, paired with detailed qualitative explanations. This structured analysis helps them quickly identify which issues require attention and how best to address them in their responses. By combining data with context, it streamlines strategy, reduces guesswork, and strengthens the overall quality of office action responses.
        </>,
        Illustration: OAScoreCardImage,
        IllustrationDescription: "Illustration of the AI-powered Office Action Response Score Card in IP Agent AI, showing quantified scores and detailed explanations that streamline office action responses, powered by patent prosecution AI, AI for office action responses, automated patent analysis, and IP Agent AI.",
        Icon: "oa_response_score_card",
        Available: true,
        Price: "$100/matter",
        SupportLawFirm: true,
        Context: [
            {
                Title: "Office Action Response - Quantified",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            IP Agent AI’s patent pending The <b>Office Action Response Score Card</b> gives attorneys a clear, quantifiable score across multiple points, paired with detailed qualitative explanations. This structured analysis helps them quickly identify which issues require attention and how best to address them in their responses. By combining data with context, it streamlines strategy, reduces guesswork, and strengthens the overall quality of office action responses.
                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: OAScoreCardSS,
                                Name: "Patent Draft Score Card | IP Agent AI | Agentic AI Platform"
                            }
                        ],
                    },
                ],

            },
            {
                Title: "Why use Office Action Response Score Card?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Quantifiable Assessment",
                                ItemBody: [
                                    "Provides a clear, measurable score for each objection, making complex office actions easier to evaluate."
                                ]
                            },

                            {
                                ItemTitle: "Qualitative Insights",
                                ItemBody: [
                                    "Every score is supported by detailed explanations, helping attorneys understand not just what to address but how."
                                ]
                            },

                            {
                                ItemTitle: "Prioritization Made Easy",
                                ItemBody: [
                                    "Helps attorneys quickly identify the most critical issues to tackle first, saving time and reducing risk."
                                ]
                            },

                            {
                                ItemTitle: "Faster Strategy Development",
                                ItemBody: [
                                    "Streamlines the response process, enabling attorneys to develop targeted strategies under tight deadlines."
                                ]
                            },

                            {
                                ItemTitle: "Reduced Errors",
                                ItemBody: [
                                    "Minimizes the chance of overlooking key examiner objections that could otherwise lead to costly rejections"
                                ]
                            },

                            {
                                ItemTitle: "Consistency Across Cases",
                                ItemBody: [
                                    "Applies the same structured evaluation to every office action, ensuring reliable and uniform responses."
                                ]
                            },

                            {
                                ItemTitle: "Stronger Responses",
                                ItemBody: [
                                    "Combining data with context leads to more persuasive, litigation-ready replies that strengthen patent protection."
                                ]
                            },

                        ]
                    },

                ],
            },
        ]
    },
    ip_compare:{
        Name: "IP Compare",
        LinkName: "ip_compare",
        SubHeader: <>
            Compare Patents & Ideas - Unearth Insights
            </>,
        HomeSubHeader: <>
            Compare Patents & Ideas
            <br/>
            Unearth Insights
            </>,
        Header: "AI-Powered Patent Comparison: Faster, Smarter, Consistent",

        Description: <>
            Compare patents and ideas instantly with qualitatively, saving you valuable time and effort!
            <br/><br/> Enterprises frequently need to compare patents, claims, or ideas against existing patents—a process that is often manual, time-consuming, and prone to non-quantitative and non-qualitative outcomes. With our proprietary technology, compare any invention or a patent to any invention or a patent.

        </>,
        Illustration: PatDiff,
        IllustrationDescription: "Side-by-side comparison tool in IP Agent AI showing claim differences between patents or ideas. This IP Compare AI feature supports patent proofreading, drafting improvements, and innovation analysis.",
        Icon: "ip_compare",
        Available: true,
        Price: "$1/matter",
        SupportLawFirm: true,

        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            Comparing two patents today is a slow, manual process where attorneys must carefully read, interpret, and map claims element by element. This approach is <b>time-consuming, error-prone, and costly,</b> often leading to inconsistent results depending on who performs the analysis. Without clear visualization or automation, the process doesn’t scale well, making it difficult to compare complex patents or large portfolios efficiently.
                        </>
                    },
                    {
                        Tag: "p",
                        Paragraph: <>
                            AI transforms patent comparison by automating the <b>claim-by-claim mapping</b> process, analyzing both text and structure in seconds instead of days. It reduces errors by applying consistent logic across every comparison, ensuring subtle differences and overlaps aren’t missed. With AI-powered visualizations and structured reports, attorneys can instantly see where two patents align, diverge, or potentially conflict. This not only saves time and cost but also makes portfolio-wide comparisons scalable — turning a manual bottleneck into a fast, reliable, and strategic advantage.
                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: PatDiffSS,
                                Name: "Patent Draft Score Card | IP Agent AI | Agentic AI Platform"
                            }
                        ],
                    },
                ],

            },
            {
                Title: "Why IP Agent AI IP Compare?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Rapid Patent Comparison",
                                ItemBody: [
                                    "IP Compare instantly contrasts two patents—or even raw ideas—by analyzing claim language, descriptions, and structures. This speed eliminates hours of manual comparison and accelerates decision-making."
                                ]
                            },

                            {
                                ItemTitle: "Accurate, Insightful Highlights",
                                ItemBody: [
                                    "Differences and similarities are clearly pinpointed and visualized, so you can quickly see overlapping claim elements or divergent disclosures. This clarity reduces misinterpretation and aids strategic evaluation."
                                ]
                            },
                            {
                                ItemTitle: "Contextual Workflow Integration",
                                ItemBody: [
                                    "As part of IP Agent AI, IP Compare fits seamlessly into existing patent workflows—whether you’re comparing drafts, analyzing competitor portfolios, or refining claims—keeping all tools unified in one agentic platform."
                                ]
                            },
                            {
                                ItemTitle: "Scalable for Complex Portfolios",
                                ItemBody: [
                                    "Whether evaluating two patents or dozens across a portfolio, IP Compare scales effortlessly, delivering consistent, reliable outputs no matter the volume of content."
                                ]
                            },
                            {
                                ItemTitle: "Time & Cost Savings",
                                ItemBody: [
                                    "By automating a repetitive, detail-oriented task, it frees attorneys to focus on strategic thinking and reduces the cost and resource drain of manual analysis."
                                ]
                            },


                        ]
                    },

                ],
            },
            {
                Title: "Who Uses IP Agent AI’s IP Compare?",
                Essential: true,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: "Law firms and enterprises worldwide rely on our proprietary AI-powered platform for fast, reliable patent Comparisons.",
                    },
                    {
                        Tag: "",
                        Text: <h3>Patent Lawyers</h3>
                    },
                    {
                        Tag: "p",
                        Paragraph: "IP Agent AI empowers patent lawyers with precise prior art discovery and litigation-ready insights — streamlining preparation and fortifying client defenses.\n",
                    },
                    {
                        Tag: "",
                        Text: <h3>Corporations</h3>
                    },
                    {
                        Tag: "p",
                        Paragraph: "Businesses rely on IP Agent AI for cost-effective invalidity searches, leveraging AI to identify weak competitor patents, reduce litigation risks, and safeguard market share.",
                    },
                    {
                       Tag: "",
                        Text: <h3>In-House Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Faster Patent Evaluations",
                                ItemBody: [
                                    "Instantly compare drafts, competitor filings, or portfolio patents without lengthy manual reviews."
                                ]
                            },
                            {
                                ItemTitle: "Better Decision-Making",
                                ItemBody: [
                                    "Clear visualizations of overlaps and differences help prioritize filings, licensing, and enforcement strategies."
                                ]
                            },
                            {
                                ItemTitle: "Cost Savings",
                                ItemBody: [
                                    "Reduce reliance on outside counsel for routine comparisons and save budget."
                                ]
                            },
                            {
                                ItemTitle: "Portfolio Management",
                                ItemBody: [
                                    "Scale patent comparisons across large portfolios with consistent accuracy."
                                ]
                            },
                        ]
                    },
                    {
                        Tag: "",
                        Text: <h3>Outside Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Efficient Client Service",
                                ItemBody: [
                                    "Generate quick, reliable comparisons to support litigation, invalidity, or FTO analysis."
                                ]
                            },
                            {
                                ItemTitle: "Stronger Arguments",
                                ItemBody: [
                                    "Highlight claim differences and similarities with precision, strengthening legal positions in disputes."
                                ]
                            },
                            {
                                ItemTitle: "Consistency",
                                ItemBody: [
                                    " Apply standardized AI-driven logic across multiple clients and cases, reducing risk of human error."
                                ]
                            },
                            {
                                ItemTitle: "Value Creation",
                                ItemBody: [
                                    "Deliver faster insights, build client trust, and focus more time on strategy instead of manual comparison"
                                ]
                            },
                        ]
                    },

                ],
            },
        ]
    },
    trade_secrets:{
        Name: "Trade Secrets",
        LinkName: "trade_secrets",
        SubHeader: "Safeguard Secrets, Protect Future",
        Header: "Protecting Enterprise Know-How as Enforceable Trade Secrets",
        HomeSubHeader: "Safeguard Secrets, Protect Future",
        Description: <>
            Trade secrets should never be patented—but how do you protect them? Protect your trade secrets with IP Agent’s Trade Secret AI Agent.        </>,
        Illustration: TradeSecretImage,
        IllustrationDescription: "Illustration of shield icon representing trade secret protection in IP Agent AI. The platform provides AI-powered tools to safeguard sensitive information, helping organizations secure confidential IP assets effectively.",
        Icon: "trade_secret",
        Available: false,
        Price: "$100/matter",
        SupportLawFirm: false,
        Context: [
            {
                Title: "",
                Essential: false,
                Body: [
                    {
                        Tag: "p",
                        Paragraph: <>
                            <b>IP Agent AI’s Trade Secrets</b> gives enterprises a structured way to capture, manage, and protect their proprietary know-how — something traditional IP systems overlook. By documenting and timestamping trade secrets with AI-driven workflows, enterprises can prove ownership, enforce confidentiality, and reduce the risk of loss or disputes. This transforms trade secret management from an informal process into a secure, defensible asset strategy.
                        </>
                    },
                    {
                        Tag: "img",
                        ImageInfo: [
                            {
                                Image: TradeSecretSS,
                                Name: "Patent Draft Score Card | IP Agent AI | Agentic AI Platform"
                            }
                        ],
                    },
                ],

            },
            {
                Title: "Why IP Agent AI’s Trade Secrets?",
                Essential: true,
                Body: [
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Structured Capture of Know-How?",
                                ItemBody: [
                                    "Transforms scattered, informal knowledge into securely documented trade secrets, ensuring critical IP doesn’t slip through the cracks."
                                ]
                            },

                            {
                                ItemTitle: "Proof of Ownership",
                                ItemBody: [
                                    "Timestamped, AI-managed records create defensible evidence of who created what and when, strengthening enforceability in disputes."
                                ]
                            },

                            {
                                ItemTitle: "Confidentiality & Security",
                                ItemBody: [
                                    "Built on private AI models, sensitive trade secret data remains protected from exposure to public systems."
                                ]
                            },

                            {
                                ItemTitle: "Simplified Management",
                                ItemBody: [
                                    "Provides a centralized platform for storing, organizing, and retrieving trade secrets, making them easier to manage over time."
                                ]
                            },

                            {
                                ItemTitle: "Reduced Risk of Loss",
                                ItemBody: [
                                    "Prevents valuable know-how from being lost when employees leave or when documentation is inconsistent."
                                ]
                            },

                            {
                                ItemTitle: "Enterprise Integration",
                                ItemBody: [
                                    "Easily connects with broader IP workflows (patents, contracts, compliance) to ensure trade secrets are part of the enterprise IP strategy"
                                ]
                            },

                            {
                                ItemTitle: "Cost Efficiency",
                                ItemBody: [
                                    "Avoids expensive legal disputes and unnecessary filings by securing trade secrets properly from the start."
                                ]
                            },

                        ]
                    },

                ],
            },
            {
                Title: "Who uses IP Agent AI’s Trade Secrets?",
                Essential: true,
                Body: [
                    {
                        Tag: "",
                        Text: <h3>For Inventors</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Easy Knowledge Capture ",
                                ItemBody: [
                                    "Record and document innovative know-how instantly without worrying about formal patent filings."
                                ]
                            },
                            {
                                ItemTitle: "Recognition & Protection",
                                ItemBody: [
                                    "Ensure individual contributions are timestamped and credited, strengthening ownership."
                                ]
                            },
                            {
                                ItemTitle: "Focus on Innovation",
                                ItemBody: [
                                    "Spend less time on admin, more time on creating."
                                ]
                            },
                        ]
                    },
                    {
                        Tag: "",
                        Text: <h3>Outside Counsels</h3>
                    },
                    {
                        Tag: "ol",
                        ListInfo: [
                            {
                                ItemTitle: "Proof of Ownership",
                                ItemBody: [
                                    "Maintain defensible records that establish clear rights in case of disputes."
                                ]
                            },
                            {
                                ItemTitle: "Strategic Flexibility",
                                ItemBody: [
                                    "Decide whether to pursue patents or keep innovations as protected trade secrets."
                                ]
                            },
                            {
                                ItemTitle: "Reduced Risk",
                                ItemBody: [
                                    "Protect confidential know-how from being lost when employees leave or competitors emerge."
                                ]
                            },
                            {
                                ItemTitle: "Integrated IP Management",
                                ItemBody: [
                                    "Manage trade secrets alongside patents and trademarks in one platform."
                                ]
                            },
                        ]
                    },

                ],
            },
        ]
    },

    // freedom_to_operate:{
    //     Name: "Freedom to Operate",
    //     LinkName: "freedom_to_operate",
    //     SubHeader: "Operate Smartly",
    //     HomeSubHeader: "Operate Smartly",
    //     Description: <>
    //         Launching a new product includes good-sized legal risks, mainly regarding <b>patent infringement</b>. IP Agent AI's <b>Freedom To Operate (FTO) analysis</b> minimizes those dangers by presenting a radical assessment of the <b>patent landscape</b>. This AI-pushed device examines present patents to become aware of ability infringement dangers and offers strategic tips to <b>mitigate legal exposure</b>. Using <b>AI for FTO analysis</b>, groups can avoid steeply-priced litigation and ensure their products comply with <b>patent law</b>. This carrier is crucial for companies entering <b>competitive markets</b>, enabling them to release merchandise without infringing on existing patents. IP Agent AI’s FTO evaluation reduces the chance of criminal disputes and enhances <b>product launch strategy</b> by ensuring full compliance with highbrow assets policies, giving companies a clear direction to the marketplace.
    //     </>,
    //     Illustration: FTOImage,
    //     Icon: FTOImage,
    //     Available: false,
    // },

}
